const AlarmTypes = {
	GENERIC_ALARM: 'GENERIC_ALARM',
	SOS: 'SOS',
	LOW_PRIO_ALARM: 'LOW_PRIO_ALARM',
	MAN_DOWN: 'MAN DOWN',
	RIPCORD: 'RIPCORD',
	AMBER_SERVER: 'AMBER_SERVER',
	AMBER: 'AMBER'
};

export default AlarmTypes;